// Between sections of a page or of markdown content.
export const sectionGap = 3;
// Within a section - a description and its input, or the items of a list.
export const verticalGap = 2;
export const listLeftOffset = 3;
export const stackedClassName = 'md-stacked';
